import i18n from 'i18next';
import LanguageDetector, {
  type DetectorOptions,
} from 'i18next-browser-languagedetector';
import HttpBackend, { type HttpBackendOptions } from 'i18next-http-backend';
import { load } from 'js-yaml';
import { initReactI18next } from 'react-i18next';

const LANGUAGE_STORAGE_KEY = 'pom-language';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init<HttpBackendOptions & DetectorOptions>({
    ns: [
      'common',
      'navigation',
      'preferences',
      'configuration',
      'errors',
      'lotSizing',
      'lotSizings',
      'productionDeclaration',
      'purchaseOrder',
      'purchaseOrders',
      'purchasePlanning',
      'settings',
      'table',
      'transits',
    ],
    defaultNS: 'common',
    react: {
      useSuspense: true,
    },
    cleanCode: true,
    fallbackLng: 'fr',
    detection: {
      order: ['localStorage', 'navigator'],
      convertDetectedLanguage: (lng) => lng.slice(0, 2),
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.yaml',
      parse: (data: string): Record<string, unknown> =>
        (load(data) as Record<string, unknown>) ?? {},
    },
  });

export default i18n;
